import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "../components/site/Hero";
import { About } from "../components/site/About";
import { Services } from "../components/site/Services";
import { Works } from "../components/site/Works";
import { FeaturedProjects } from "../components/site/FeaturedProjects";
import { Gallery } from "../components/site/Gallery";
import { Credentials } from "../components/site/Credentials";
import { Contact } from "../components/site/Contact";
import { Seo, businessJsonLd } from "../components/site/Seo";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView(), 100);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <main>
      <Seo
        description="Vata Infrastructures is a KPWD Class-I civil contractor in Bengaluru building forest chain link fencing, barbed wire fencing, elephant proof trenches, railway barricades, wildlife holding rooms and dam gate works across Karnataka."
        jsonLd={businessJsonLd()}
      />
      <Hero />
      <About />
      <Services />
      <Works />
      <FeaturedProjects />
      <Gallery />
      <Credentials />
      <Contact />
    </main>
  );
}
